import i18n from 'i18next'

import { formatDate } from './formatDate'

import { OfferItem, OfferUsedStatus } from '~types/offer'

export const getOfferStatus = ({
  buyStatus,
  endDate,
  offerLeft,
  discountUsed = OfferUsedStatus.NOT_USED,
}: Partial<Pick<OfferItem, 'buyStatus' | 'endDate' | 'offerLeft' | 'discountUsed'>>) => {
  if (discountUsed) return i18n.t('offer_details_screen.offer_used')
  if (buyStatus)
    return endDate
      ? i18n.t('offer_details_screen.offer_valid_till') + ' ' + formatDate(endDate)
      : i18n.t('common.unlimited_offer')

  if (typeof offerLeft === 'number') {
    return offerLeft + ' ' + i18n.t(`common.${offerLeft === 1 ? 'offer_left' : 'offers_left'}`)
  }
}
